/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectResponseDashboardDto } from '../../models/project-response-dashboard-dto';

export interface DashboardProjectsControllerAddOrUpdateTeamMemberV1$Params {
  projectId: string;
      body: {

/**
 * Team member ID (only for UPDATE)
 */
'id'?: string;

/**
 * Full name (required for CREATE)
 */
'name'?: string;

/**
 * Position/role (required for CREATE)
 */
'position'?: string;

/**
 * LinkedIn profile URL (optional)
 */
'linkedinUrl'?: string;

/**
 * Description/bio (required for CREATE)
 */
'description'?: string;

/**
 * Team member photo (optional)
 */
'file'?: Blob;
}
}

export function dashboardProjectsControllerAddOrUpdateTeamMemberV1(http: HttpClient, rootUrl: string, params: DashboardProjectsControllerAddOrUpdateTeamMemberV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectResponseDashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerAddOrUpdateTeamMemberV1.PATH, 'patch');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectResponseDashboardDto>;
    })
  );
}

dashboardProjectsControllerAddOrUpdateTeamMemberV1.PATH = '/v1/dashboard/projects/{projectId}/team-members';
